import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the table menu view.
 * @extends JetView
 */
export default class tableMenuView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        var url = devConfig.geturlApi() + 'UserManagement/GetMenusUserReports'; // API endpoint for user reports
        var filter = ''; // Filter string for data fetching
        var country = ''; // Country variable for filtering
        const id_partner = this.getParam('partner', true); // Partner ID from parameters

        /**
         * Formats a value as a percentage string.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return value + '%';
        }

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 80, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close edit'></span>"; // Template for edit icon
                                    },
                                },
                                { id: 'Year', header: _('Año'), width: 100 }, // Year column
                                {
                                    id: 'Mounth', // Month column
                                    header: _('Mes'),
                                    width: 200,
                                    options: [
                                        // Month options for dropdown
                                        { id: '01', value: _('Enero') },
                                        { id: '02', value: _('Febrero') },
                                        { id: '03', value: _('Marzo') },
                                        { id: '04', value: _('Abril') },
                                        { id: '05', value: _('Mayo') },
                                        { id: '06', value: _('Junio') },
                                        { id: '07', value: _('Julio') },
                                        { id: '08', value: _('Agosto') },
                                        { id: '09', value: _('Septiembre') },
                                        { id: '10', value: _('Octubre') },
                                        { id: '11', value: _('Noviembre') },
                                        { id: '12', value: _('Diciembre') },
                                    ],
                                },
                                {
                                    id: 'PercentDepositValue', // Deposit percentage column
                                    header: _('Porcentaje valor de depósitos'),
                                    width: 200,
                                    format: percentFormat, // Format as percentage
                                },
                                {
                                    id: 'PercentValueNonSportsAwards', // Non-sports awards percentage column
                                    header: _('Porcentaje premios no deportivos'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentRetirementValue', // Retirement percentage column
                                    header: _('Porcentaje valor de retiros'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentValueSportsBonds', // Sports bonds percentage column
                                    header: _('Porcentaje de bonos deportivos'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentValueSportsBets', // Sports bets percentage column
                                    header: _('Porcentaje de apuestas deportivas'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentValueNonSportsBounds', // Non-sports bonds percentage column
                                    header: _('Porcentaje de bonos no deportivos'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentValueNonSportBets', // Non-sports bets percentage column
                                    header: _('Porcentaje de apuestas no deportivas'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentValueTickets', // Tickets percentage column
                                    header: _('Porcentaje de tickets'),
                                    width: 200,
                                    format: percentFormat,
                                },
                                {
                                    id: 'PercentValueSportsAwards', // Sports awards percentage column
                                    header: _('Porcentaje de premios deportivos'),
                                    width: 200,
                                    format: percentFormat,
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Edit button click event
                                    vthis.app.callEvent('openEdit', [{}]); // Trigger edit event
                                },
                            },
                            math: true, // Enable mathematical operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the DataTable instance
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Setting/GetControlSettings'; // API endpoint for control settings
        const id_partner = this.getParam('partner', true); // Partner ID from parameters
        var country = ''; // Country variable for filtering
        var filter = ''; // Filter string for data fetching

        // Event listener for control filtering
        this.on(this.app, 'control:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Build filter string
                    if (object[i][0] == 'Country') {
                        country = object[i][1]; // Set country variable
                    }
                }
            }
            grid.clearAll(); // Clear the DataTable
            grid.load(url + '?start=0&count=1000' + string1); // Load data with filters
            filter = string1; // Update filter variable
        });

        // Popup window for editing controls
        var popupEdit = webix.ui({
            view: 'window',
            id: 'editControl', // ID for the edit control window
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            width: 650, // Window width
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar') }, // Edit label
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on close
                        },
                    },
                ],
            },
            position: 'center', // Center the window
            modal: true, // Modal window
            body: {
                view: 'form', // Form inside the window
                id: 'editform', // ID for the edit form
                elements: [
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Year input field
                                labelPosition: 'top',
                                label: _('Año'),
                                name: 'Year',
                                readonly: true, // Read-only field
                                required: false,
                            },
                            {
                                view: 'text', // Month input field
                                labelPosition: 'top',
                                label: _('Mes'),
                                name: 'Mounth',
                                readonly: true, // Read-only field
                                required: true,
                                on: {
                                    onChange: function (data, obj) {
                                        // Change event for month field
                                        let currentValue = this.getValue(); // Get current value
                                        let months = {
                                            // Month mapping
                                            '01': 'Enero',
                                            '02': 'Febrero',
                                            '03': 'Marzo',
                                            '04': 'Abril',
                                            '05': 'Mayo',
                                            '06': 'Junio',
                                            '07': 'Julio',
                                            '08': 'Agosto',
                                            '09': 'Septiembre',
                                            10: 'Octubre',
                                            11: 'Noviembre',
                                            12: 'Diciembre',
                                        };
                                        if (months[currentValue] != undefined) {
                                            this.setValue(months[currentValue]); // Set month value
                                        }
                                    },
                                },
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Deposit percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje valor de depósitos'),
                                name: 'PercentDepositValue',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                            {
                                view: 'text', // Non-sports awards percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje premios no deportivos'),
                                name: 'PercentValueNonSportsAwards',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Retirement percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje valor de retiros'),
                                name: 'PercentRetirementValue',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                            {
                                view: 'text', // Sports bonds percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje de bonos deportivos'),
                                name: 'PercentValueSportsBonds',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Sports bets percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje de apuestas deportivas'),
                                name: 'PercentValueSportsBets',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                            {
                                view: 'text', // Non-sports bonds percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje de bonos no deportivos'),
                                name: 'PercentValueNonSportsBounds',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Non-sports bets percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje de apuestas no deportivas'),
                                name: 'PercentValueNonSportBets',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                            {
                                view: 'text', // Tickets percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje de tickets'),
                                name: 'PercentValueTickets',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text', // Sports awards percentage input field
                                labelPosition: 'top',
                                label: _('Porcentaje de premios deportivos'),
                                name: 'PercentValueSportsAwards',
                                readonly: false,
                                required: true,
                                type: 'number',
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on cancel
                                    $$('editform').setValues(
                                        $$('editform').getCleanValues(), // Reset form values
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editform').getValues(); // Get form values
                                    if ($$('editform').validate()) {
                                        // Validate form
                                        let sendMonds; // Variable for sending month
                                        let months = {
                                            // Month mapping for sending
                                            Enero: '01',
                                            Febrero: '02',
                                            Marzo: '03',
                                            Abril: '04',
                                            Mayo: '05',
                                            Junio: '06',
                                            Julio: '07',
                                            Agosto: '08',
                                            Sepiembre: '09',
                                            Octubre: '10',
                                            Noviembre: '11',
                                            Diciembre: '12',
                                        };
                                        if (months[values.Mounth] != undefined) {
                                            sendMonds = months[values.Mounth]; // Set month for sending
                                        }
                                        const params = {
                                            // Parameters for API request
                                            Partner: id_partner,
                                            Country: country,
                                            Year: values.Year,
                                            Mounth: sendMonds,
                                            PercentDepositValue: values.PercentDepositValue,
                                            PercentValueNonSportsAwards: values.PercentValueNonSportsAwards,
                                            PercentRetirementValue: values.PercentRetirementValue,
                                            PercentValueSportsBonds: values.PercentValueSportsBonds,
                                            PercentValueSportsBets: values.PercentValueSportsBets,
                                            PercentValueNonSportsBounds: values.PercentValueNonSportsBounds,
                                            PercentValueNonSportBets: values.PercentValueNonSportBets,
                                            PercentValueTickets: values.PercentValueTickets,
                                            PercentValueSportsAwards: values.PercentValueSportsAwards,
                                        };
                                        webix
                                            .ajax() // AJAX request to save data
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'es/Setting/EditControl', // API endpoint for editing control
                                                params, // Parameters to send
                                                {
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var resp = JSON.parse(text); // Parse response
                                                        if (!resp.HasError) {
                                                            webix.message('Control editado satisfactoriamente'); // Success message
                                                            grid.clearAll(); // Clear the DataTable
                                                            grid.load(url + '?start=0&count=1000' + filter); // Reload data
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide the window after saving
                                    } else {
                                        webix.message({
                                            // Error message for validation failure
                                            title: _('¡Error!'),
                                            type: 'alert-error',
                                            text: _('Completa los campos...'),
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
                elementsConfig: {
                    on: {
                        onChange: function () {
                            this.validate(); // Validate fields on change
                        },
                    },
                },
                rules: {
                    // Validation rules for percentage fields
                    PercentDepositValue: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueNonSportsAwards: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentRetirementValue: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueSportsBonds: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueSportsBets: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueNonSportsBounds: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueNonSportBets: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueTickets: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                    PercentValueSportsAwards: function (value) {
                        return value >= 0 && value <= 100; // Validate range
                    },
                },
            },
        });
        $$('editform').bind($$('datatable')); // Bind the edit form to the DataTable
        this.on(this.app, 'openEdit', (item) => {
            popupEdit.show(); // Show the edit popup when triggered
        });
    }
}

// FILE DOCUMENTED
